import { StorageCollectionName } from '@livv/models';
import { FC, useContext } from 'react';
import { DecisionSearchContext } from './DecisionSearchProvider';
import DecisionSearchScopeSelector from './DecisionSearchScopeSelector';
import FullText from '@components/FullText';
import DisplayFullText from '@components/FullText/DisplayFullText';
import { DocumentSearchTarget } from '@models/searchable';

const unavailableTarget: DocumentSearchTarget = {
    text: '',
    updateContent: () => undefined,
};

interface DecisionFullTextProps {
    decisionId: string;
    fullText?: string;
}

const DecisionFullText: FC<DecisionFullTextProps> = ({ decisionId, fullText }) => {
    const searchContext = useContext(DecisionSearchContext);
    if (!searchContext) throw new Error('Decision search context needed');

    const { analysisTarget, hasFocusedAnalysis, scope, setScope } = searchContext;
    const searchTarget = scope === 'analysis' ? analysisTarget ?? unavailableTarget : undefined;
    const searchControls = hasFocusedAnalysis ? (
        <DecisionSearchScopeSelector
            analysisAvailable={Boolean(analysisTarget)}
            onChange={setScope}
            value={scope}
        />
    ) : undefined;
    const commonProps = {
        sanitizeOptions: { insertLawLexTags: true },
        searchControls,
        searchTarget,
        searchTargetId: scope,
        withSearch: true,
    };

    return fullText ? (
        <DisplayFullText {...commonProps} unsanitizedContent={fullText} />
    ) : (
        <FullText
            {...commonProps}
            collectionName={StorageCollectionName.DECISIONS_FULL_TEXT}
            documentId={decisionId}
        />
    );
};

export default DecisionFullText;
